export default __webpack_public_path__ + "static/media/3233 spice rack B top.75e3922d.png";